import "./DatiPersonaliNonRiconosciutoPage.css";
import { t } from "../../../services/formatters";
import { Button } from "../../../components/Button";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { FormDatiUtenteC5 } from "../../../components/FormDatiUtenteC5";
import { useDatiPersonaliNonRiconosciutoPage } from "./useDatiPersonaliNonRiconosciutoPage";
import { ErrorModal } from "../../../components/ErrorModal";
import { useEffect } from "react";
import { InformativeC5 } from "../../../components/InformativeC5";
import { Riepilogo } from "../../../components/Riepilogo";

export const DatiPersonaliNonRiconosciutoC5Page = () => {
    const { next, read, lockFields, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliNonRiconosciutoPage();

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/c5/fissa-appuntamento/dati-personali-non-riconosciuto",
            funnelVersion: "nuovo",
            FA_funnel: "Cessione del quinto",
            crmIdentification: "nuovo utente",
            capFiliale: read("cap"),
        });
    }, []);

    return (
        <div id="dati-personali-non-riconosciuto-page">
            <Breadcrumb />

            {read("id_filiale_direct_c5") && <Riepilogo />}
            {/* <Riepilogo /> */}

            {lockFields && (
                <div className={`section page-title-component center-on-tablet`}>
                    <h1>
                        <span>Ciao {read("nome")}!</span>
                    </h1>
                </div>
            )}

            <FormDatiUtenteC5 lockFields={lockFields} title={t("compila_dati")} />

            <InformativeC5 />

            <div className="section text-center">
                <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
                {/* {isCreaAppuntamentoError() && <p>errore crea</p>} */}
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>
        </div>
    );
};
